import { useSelector } from 'react-redux';
import { ImpersonationBanner } from '..';
import { Link, Outlet, useLocation, useSearchParams } from 'react-router-dom';

import { Footer } from '../LayoutComponents';
import { UnauthenticatedModals } from '../Modals';

//Images
import { ReactComponent as Logo } from '../../images/logo.svg';
import { ReactComponent as Tagline } from '../../images/gem-sleep-tagline.svg';
import { EmailVerification } from '../EmailVerification';

//Zendesk Web Widget
// import { isWeekend } from 'date-fns';
// import { formatInTimeZone } from 'date-fns-tz';
// import useWebWidget from '../../utils/useWebWidget';

function LogoLink() {
    const location = useLocation();

    return (
        <div className="mx-auto mt-20 py-8 xl:py-0 flex flex-col items-center">
            {location.pathname === '/' ? (
                <>
                    <a href="https://mygemsleep.com/" target="_blank" rel="noreferrer">
                        <Logo className="w-[50px] lg:w-auto" />
                    </a>
                    <Tagline className="mt-2 w-32 lg:mt-4 lg:w-auto" />
                </>
            ) : (
                <>
                    <Link to="/">
                        <Logo className="w-[50px] lg:w-auto" />
                    </Link>
                    <Tagline className="mt-2 w-32 lg:mt-4 lg:w-auto" />
                </>
            )}
        </div>
    );
}

function RedirectBanner() {
    return location.pathname === '/' || location.pathname === '/sign-in' ? (
        <div className="absolute top-0 right-0 left-0 w-full md:w-auto justify-center h-[4rem] flex items-center z-20 bg-purple-super-dark mb-4">
            {location.pathname === '/' && (
                <p className="text-sm text-gray-light">
                    Already have an account?{' '}
                    <Link
                        to="/sign-in"
                        className="ml-0.5 border-b border-gem-green text-sm font-bold text-white">
                        Sign In
                    </Link>
                </p>
            )}
            {location.pathname === '/sign-in' && (
                <p className="text-sm text-gray-light">
                    New to GEM SLEEP?{' '}
                    <Link
                        to="/"
                        className="ml-0.5 border-b border-gem-green text-sm font-bold text-white">
                        Get Started
                    </Link>
                </p>
            )}
        </div>
    ) : null;
}

function UnauthenticatedLayout() {
    const [searchParams] = useSearchParams();
    const location = useLocation();

    //Check for email verification token, if it exists, render the verification component
    const verificationToken = searchParams.get('verificationToken');

    //ZENDESK Web Widget, currently turned off
    //Determine hour in CST, use it to determine if it is working hours
    // const hourInCST = parseInt(formatInTimeZone(new Date(), 'America/Chicago', 'HH'));
    // const isWorkingHours = hourInCST <= 17 && hourInCST >= 8;
    // useWebWidget(!isWeekend(new Date()) && isWorkingHours);

    return (
        <div className="relative flex min-h-screen flex-col bg-purple-dark text-white">
            <ImpersonationBanner />
            <RedirectBanner />

            {location.pathname.indexOf('assessment') < 0 && <LogoLink />}

            <div className="flex-1 mb-4">
                <Outlet />
                {verificationToken ? (
                    <EmailVerification verificationToken={verificationToken} />
                ) : null}
            </div>

            <Footer />
            <UnauthenticatedModals />
        </div>
    );
}

export default UnauthenticatedLayout;
